import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LaddaModule } from 'angular2-ladda';
import { ExcelModule } from '@progress/kendo-angular-grid';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';
import { LeadArchiveDialogComponent } from './lead-archive-dialog/lead-archive-dialog.component';
import { LeadDetailDialogComponent } from './lead-detail-dialog/lead-detail-dialog.component';
import { LeadPostponeDialogComponent } from './lead-postpone-dialog/lead-postpone-dialog.component';
import { LeadsRoutingModule } from './leads-routing.module';

@NgModule({
	declarations: [
		LeadsRoutingModule.components,
	],
	entryComponents: [
		LeadDetailDialogComponent,
		LeadPostponeDialogComponent,
		LeadArchiveDialogComponent,
	],
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		RouterModule,
		LaddaModule,
		ExcelModule,
		LayoutModule,
		PerfectScrollbarModule,
		MatBottomSheetModule,
		MatListModule,
		InfiniteScrollModule
	],
})
export class LeadsModule { }
